export const state = {
  mainGenre: [
    { code: '1', name: '指定しない' },
    { code: 'H', name: 'グルメ' },
    { code: 'J', name: 'ショッピング' },
    { code: 'E', name: '温泉・入浴施設' },
    { code: 'C', name: '観光名所、動物園など' },
    { code: 'D', name: '美術館、博物館' },
    { code: 'M', name: '道の駅' },
    { code: 'L', name: 'ガソリンスタンド' },
    { code: 'G', name: 'アミューズメント' },
    { code: 'B', name: '遊園地・テーマパーク' },
    { code: 'K', name: '暮らし' },
    { code: 'F', name: 'アウトドア' },
    { code: 'Q', name: 'SA・PA（サービスエリア）' },
    { code: 'A', name: '宿泊' },
    { code: 'N', name: '旅行' },
    { code: 'P', name: 'カルチャー' },
    { code: 'Y', name: 'その他' },
  ],
  genreList: [
    {
      genrecode: 'A',
      genreName: '宿泊',
      subGenreCode: 'A1',
      subGenreName: 'ホテル',
    },
    {
      genrecode: 'A',
      genreName: '宿泊',
      subGenreCode: 'A2',
      subGenreName: '旅館',
    },
    {
      genrecode: 'A',
      genreName: '宿泊',
      subGenreCode: 'A0',
      subGenreName: '公共の宿・民宿・ペンション他',
    },
    {
      genrecode: 'A',
      genreName: '宿泊',
      subGenreCode: 'A5',
      subGenreName: 'キャンプ場',
    },
    {
      genrecode: 'A',
      genreName: '宿泊',
      subGenreCode: 'A6',
      subGenreName: 'ペットと泊まれる宿',
    },
    {
      genrecode: 'B',
      genreName: '遊園地・テーマパーク',
      subGenreCode: 'B1',
      subGenreName: '遊園地・テーマパーク',
    },
    {
      genrecode: 'B',
      genreName: '遊園地・テーマパーク',
      subGenreCode: 'B0',
      subGenreName: 'プール',
    },
    {
      genrecode: 'C',
      genreName: '観光名所、動物園など',
      subGenreCode: 'C0',
      subGenreName: '史跡・庭園',
    },
    {
      genrecode: 'C',
      genreName: '観光名所、動物園など',
      subGenreCode: 'C2',
      subGenreName: '遊覧船・観光船',
    },
    {
      genrecode: 'C',
      genreName: '観光名所、動物園など',
      subGenreCode: 'C3',
      subGenreName: 'ロープウェイ',
    },
    {
      genrecode: 'C',
      genreName: '観光名所、動物園など',
      subGenreCode: 'C6',
      subGenreName: '植物園・公園',
    },
    {
      genrecode: 'C',
      genreName: '観光名所、動物園など',
      subGenreCode: 'C7',
      subGenreName: '水族館・動物園・牧場',
    },
    {
      genrecode: 'C',
      genreName: '観光名所、動物園など',
      subGenreCode: 'C8',
      subGenreName: '展望台・タワー',
    },
    {
      genrecode: 'C',
      genreName: '観光名所、動物園など',
      subGenreCode: 'C9',
      subGenreName: '酒蔵・ワイナリー',
    },
    {
      genrecode: 'C',
      genreName: '観光名所、動物園など',
      subGenreCode: 'CA',
      subGenreName: 'その他',
    },
    {
      genrecode: 'D',
      genreName: '美術館、博物館',
      subGenreCode: 'D1',
      subGenreName: '美術館',
    },
    {
      genrecode: 'D',
      genreName: '美術館、博物館',
      subGenreCode: 'D0',
      subGenreName: '博物館',
    },
    {
      genrecode: 'D',
      genreName: '美術館、博物館',
      subGenreCode: 'D3',
      subGenreName: '資料館',
    },
    {
      genrecode: 'D',
      genreName: '美術館、博物館',
      subGenreCode: 'D4',
      subGenreName: '科学館',
    },
    {
      genrecode: 'D',
      genreName: '美術館、博物館',
      subGenreCode: 'D5',
      subGenreName: 'プラネタリウム他',
    },
    {
      genrecode: 'F',
      genreName: 'アウトドア',
      subGenreCode: 'F1',
      subGenreName: 'キャンプ・バーベキュー',
    },
    {
      genrecode: 'F',
      genreName: 'アウトドア',
      subGenreCode: 'F2',
      subGenreName: 'スキー・スノーボード',
    },
    {
      genrecode: 'F',
      genreName: 'アウトドア',
      subGenreCode: 'F0',
      subGenreName: 'スケート',
    },
    {
      genrecode: 'F',
      genreName: 'アウトドア',
      subGenreCode: 'F3',
      subGenreName: 'ゴルフ',
    },
    {
      genrecode: 'F',
      genreName: 'アウトドア',
      subGenreCode: 'F4',
      subGenreName: '味覚狩り',
    },
    {
      genrecode: 'F',
      genreName: 'アウトドア',
      subGenreCode: 'F5',
      subGenreName: '釣り',
    },
    {
      genrecode: 'F',
      genreName: 'アウトドア',
      subGenreCode: 'FY',
      subGenreName: 'その他',
    },
    {
      genrecode: 'G',
      genreName: 'アミューズメント',
      subGenreCode: 'G4',
      subGenreName: 'ボウリング',
    },
    {
      genrecode: 'G',
      genreName: 'アミューズメント',
      subGenreCode: 'G5',
      subGenreName: 'カラオケ',
    },
    {
      genrecode: 'G',
      genreName: 'アミューズメント',
      subGenreCode: 'G3',
      subGenreName: '映画館',
    },
    {
      genrecode: 'G',
      genreName: 'アミューズメント',
      subGenreCode: 'G1',
      subGenreName: 'スポーツ観戦',
    },
    {
      genrecode: 'G',
      genreName: 'アミューズメント',
      subGenreCode: 'G2',
      subGenreName: 'ホール・劇場',
    },
    {
      genrecode: 'G',
      genreName: 'アミューズメント',
      subGenreCode: 'G0',
      subGenreName: '音楽鑑賞・オーケストラ',
    },
    {
      genrecode: 'G',
      genreName: 'アミューズメント',
      subGenreCode: 'G6',
      subGenreName: 'ネットカフェ',
    },
    {
      genrecode: 'G',
      genreName: 'アミューズメント',
      subGenreCode: 'G7',
      subGenreName: 'ゲームセンター',
    },
    {
      genrecode: 'G',
      genreName: 'アミューズメント',
      subGenreCode: 'G8',
      subGenreName: 'キッズランド',
    },
    {
      genrecode: 'G',
      genreName: 'アミューズメント',
      subGenreCode: 'G9',
      subGenreName: '動画・音楽・配信サービス',
    },
    {
      genrecode: 'G',
      genreName: 'アミューズメント',
      subGenreCode: 'GY',
      subGenreName: 'その他',
    },
    {
      genrecode: 'H',
      genreName: 'グルメ',
      subGenreCode: 'H0',
      subGenreName: '和食',
    },
    {
      genrecode: 'H',
      genreName: 'グルメ',
      subGenreCode: 'H5',
      subGenreName: '洋食・西洋料理',
    },
    {
      genrecode: 'H',
      genreName: 'グルメ',
      subGenreCode: 'H6',
      subGenreName: '中華料理',
    },
    {
      genrecode: 'H',
      genreName: 'グルメ',
      subGenreCode: 'H7',
      subGenreName: 'カレー・アジア・エスニック',
    },
    {
      genrecode: 'H',
      genreName: 'グルメ',
      subGenreCode: 'H2',
      subGenreName: 'カフェ・スイーツ',
    },
    {
      genrecode: 'H',
      genreName: 'グルメ',
      subGenreCode: 'H3',
      subGenreName: 'ファストフード',
    },
    {
      genrecode: 'H',
      genreName: 'グルメ',
      subGenreCode: 'H8',
      subGenreName: 'ファミレス',
    },
    {
      genrecode: 'H',
      genreName: 'グルメ',
      subGenreCode: 'H9',
      subGenreName: '焼肉・しゃぶしゃぶ・ステーキ',
    },
    {
      genrecode: 'H',
      genreName: 'グルメ',
      subGenreCode: 'HA',
      subGenreName: 'ビュッフェ・バイキング',
    },
    {
      genrecode: 'H',
      genreName: 'グルメ',
      subGenreCode: 'HB',
      subGenreName: '回転寿司・すし',
    },
    {
      genrecode: 'H',
      genreName: 'グルメ',
      subGenreCode: 'HC',
      subGenreName: '麺（ラーメン、うどん、そば）',
    },
    {
      genrecode: 'H',
      genreName: 'グルメ',
      subGenreCode: 'HD',
      subGenreName: '居酒屋・ダイニング',
    },
    {
      genrecode: 'H',
      genreName: 'グルメ',
      subGenreCode: 'HE',
      subGenreName: '宅配ピザ・デリバリー',
    },
    {
      genrecode: 'H',
      genreName: 'グルメ',
      subGenreCode: 'HF',
      subGenreName: '弁当・惣菜・テイクアウト',
    },
    {
      genrecode: 'H',
      genreName: 'グルメ',
      subGenreCode: 'HY',
      subGenreName: 'その他',
    },
    {
      genrecode: 'J',
      genreName: 'ショッピング',
      subGenreCode: 'J0',
      subGenreName: '家電、家具、インテリア',
    },
    {
      genrecode: 'J',
      genreName: 'ショッピング',
      subGenreCode: 'J3',
      subGenreName: '百貨店、ショッピングセンター',
    },
    {
      genrecode: 'J',
      genreName: 'ショッピング',
      subGenreCode: 'J4',
      subGenreName: 'ドラッグストア・メガネ・コンタクトレンズ',
    },
    {
      genrecode: 'J',
      genreName: 'ショッピング',
      subGenreCode: 'J6',
      subGenreName: 'ファッション・アクセサリー・時計・雑貨',
    },
    {
      genrecode: 'J',
      genreName: 'ショッピング',
      subGenreCode: 'J7',
      subGenreName: 'ベビー・キッズ用品',
    },
    {
      genrecode: 'J',
      genreName: 'ショッピング',
      subGenreCode: 'J8',
      subGenreName: '手芸、工芸',
    },
    {
      genrecode: 'J',
      genreName: 'ショッピング',
      subGenreCode: 'J9',
      subGenreName: 'カー用品',
    },
    {
      genrecode: 'J',
      genreName: 'ショッピング',
      subGenreCode: 'JA',
      subGenreName: 'ペット用品',
    },
    {
      genrecode: 'J',
      genreName: 'ショッピング',
      subGenreCode: 'JB',
      subGenreName: 'スポーツ・自転車・アウトドア用品',
    },
    {
      genrecode: 'J',
      genreName: 'ショッピング',
      subGenreCode: 'JC',
      subGenreName: 'アウトレット',
    },
    {
      genrecode: 'J',
      genreName: 'ショッピング',
      subGenreCode: 'JD',
      subGenreName: 'リサイクル・ディスカウントショップ',
    },
    {
      genrecode: 'J',
      genreName: 'ショッピング',
      subGenreCode: 'JE',
      subGenreName: 'みやげ品販売',
    },
    {
      genrecode: 'J',
      genreName: 'ショッピング',
      subGenreCode: 'JY',
      subGenreName: 'その他',
    },
    {
      genrecode: 'K',
      genreName: '暮らし',
      subGenreCode: 'K3',
      subGenreName: '美・理容室',
    },
    {
      genrecode: 'K',
      genreName: '暮らし',
      subGenreCode: 'K0',
      subGenreName: 'ハウスクリーニング・家事代行',
    },
    {
      genrecode: 'K',
      genreName: '暮らし',
      subGenreCode: 'K2',
      subGenreName: 'クリーニング店',
    },
    {
      genrecode: 'K',
      genreName: '暮らし',
      subGenreCode: 'K7',
      subGenreName: '洋服仕立て直し・リメイク',
    },
    {
      genrecode: 'K',
      genreName: '暮らし',
      subGenreCode: 'K8',
      subGenreName: '靴・鍵',
    },
    {
      genrecode: 'K',
      genreName: '暮らし',
      subGenreCode: 'K5',
      subGenreName: '引越し',
    },
    {
      genrecode: 'K',
      genreName: '暮らし',
      subGenreCode: 'K1',
      subGenreName: '駐車場',
    },
    {
      genrecode: 'K',
      genreName: '暮らし',
      subGenreCode: 'K9',
      subGenreName: 'レンタル・WiFi他',
    },
    {
      genrecode: 'K',
      genreName: '暮らし',
      subGenreCode: 'K4',
      subGenreName: 'ヨガ・スポーツクラブ・プール',
    },
    {
      genrecode: 'K',
      genreName: '暮らし',
      subGenreCode: 'KA',
      subGenreName: 'フォトスタジオ・写真館',
    },
    {
      genrecode: 'K',
      genreName: '暮らし',
      subGenreCode: 'KB',
      subGenreName: '健診・人間ドック',
    },
    {
      genrecode: 'K',
      genreName: '暮らし',
      subGenreCode: 'KY',
      subGenreName: 'その他',
    },
    {
      genrecode: 'L',
      genreName: 'ガソリンスタンド',
      subGenreCode: 'L1',
      subGenreName: 'ＥＮＥＯＳ',
    },
    {
      genrecode: 'L',
      genreName: 'ガソリンスタンド',
      subGenreCode: 'L2',
      subGenreName: '出光',
    },
    {
      genrecode: 'L',
      genreName: 'ガソリンスタンド',
      subGenreCode: 'L3',
      subGenreName: 'カーエネクス',
    },
    {
      genrecode: 'L',
      genreName: 'ガソリンスタンド',
      subGenreCode: 'L4',
      subGenreName: 'コスモ石油',
    },
    {
      genrecode: 'L',
      genreName: 'ガソリンスタンド',
      subGenreCode: 'L5',
      subGenreName: '昭和シェル石油',
    },
    {
      genrecode: 'L',
      genreName: 'ガソリンスタンド',
      subGenreCode: 'L6',
      subGenreName: 'ＳＯＬＡＴＯ',
    },
    // {
    //   genrecode: 'L',
    //   genreName: 'ガソリンスタンド',
    //   subGenreCode: 'L7',
    //   subGenreName: 'Ｍｅ',
    // },
    {
      genrecode: 'L',
      genreName: 'ガソリンスタンド',
      subGenreCode: 'L8',
      subGenreName: 'キグナス石油',
    },
    {
      genrecode: 'L',
      genreName: 'ガソリンスタンド',
      subGenreCode: 'L9',
      subGenreName: 'ナヴィ',
    },
    {
      genrecode: 'L',
      genreName: 'ガソリンスタンド',
      subGenreCode: 'LA',
      subGenreName: 'ゼネラル',
    },
    // {
    //   genrecode: 'L',
    //   genreName: 'ガソリンスタンド',
    //   subGenreCode: 'LB',
    //   subGenreName: 'エッソ',
    // },
    // {
    //   genrecode: 'L',
    //   genreName: 'ガソリンスタンド',
    //   subGenreCode: 'LC',
    //   subGenreName: 'モービル',
    // },
    {
      genrecode: 'L',
      genreName: 'ガソリンスタンド',
      subGenreCode: 'LD',
      subGenreName: 'ＪＡ－ＳＳ',
    },
    // {
    //   genrecode: 'L',
    //   genreName: 'ガソリンスタンド',
    //   subGenreCode: 'LE',
    //   subGenreName: 'ぺトラス',
    // },
    {
      genrecode: 'L',
      genreName: 'ガソリンスタンド',
      subGenreCode: 'LY',
      subGenreName: 'その他',
    },
    {
      genrecode: 'N',
      genreName: '旅行',
      subGenreCode: 'N1',
      subGenreName: 'フェリー',
    },
    {
      genrecode: 'N',
      genreName: '旅行',
      subGenreCode: 'N2',
      subGenreName: 'レンタカー',
    },
    {
      genrecode: 'N',
      genreName: '旅行',
      subGenreCode: 'N3',
      subGenreName: 'レンタルバイク',
    },
    {
      genrecode: 'N',
      genreName: '旅行',
      subGenreCode: 'N4',
      subGenreName: 'レンタルサイクル',
    },
    {
      genrecode: 'N',
      genreName: '旅行',
      subGenreCode: 'N5',
      subGenreName: 'パッケージ旅行',
    },
    {
      genrecode: 'N',
      genreName: '旅行',
      subGenreCode: 'N6',
      subGenreName: '旅行関連用品 他',
    },
    // {
    //   genrecode: 'N',
    //   genreName: '旅行',
    //   subGenreCode: 'NY',
    //   subGenreName: 'その他',
    // },
    {
      genrecode: 'P',
      genreName: 'カルチャー',
      subGenreCode: 'P1',
      subGenreName: 'カルチャーセンター・習い事',
    },
    {
      genrecode: 'P',
      genreName: 'カルチャー',
      subGenreCode: 'P2',
      subGenreName: '体験',
    },
    // {
    //   genrecode: 'P',
    //   genreName: 'カルチャー',
    //   subGenreCode: 'P3',
    //   subGenreName: 'オーケストラ',
    // },
    {
      genrecode: 'P',
      genreName: 'カルチャー',
      subGenreCode: 'PY',
      subGenreName: 'その他',
    },
    {
      genrecode: 'Y',
      genreName: 'その他',
      subGenreCode: 'Y1',
      subGenreName: 'マイカー回送',
    },
    {
      genrecode: 'Y',
      genreName: 'その他',
      subGenreCode: 'Y2',
      subGenreName: '自動車学校',
    },
    // {
    //   genrecode: 'Y',
    //   genreName: 'その他',
    //   subGenreCode: 'YJ',
    //   subGenreName: 'JAF支部',
    // },
    {
      genrecode: 'Y',
      genreName: 'その他',
      subGenreCode: 'YY',
      subGenreName: 'その他',
    },
  ],
}
